import {
  IsNotEmpty,
  IsOptional,
  IsArray,
  ArrayMinSize,
  IsIn,
} from "class-validator";
import { Constants } from "@eagerdog/constants";

import { EventDogShowsDto } from "./event-dog-shows.dto";
import { EventAddOnDto } from "./event-add-on.dto";

export class EventRegistrationCreateDto {
  @IsArray()
  @ArrayMinSize(1)
  dog_show_registrations: EventDogShowsDto[];

  @IsOptional()
  @IsArray()
  add_ons?: EventAddOnDto[];

  @IsNotEmpty()
  @IsIn(Object.values(Constants.payment_method_type))
  payment_method_type: string = Constants.payment_method_type.card;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.registration_kind))
  registration_kind: string = Constants.registration_kind.owner;

  @IsOptional()
  payment_card_type?: string = Constants.payment_card_type.unknown;

  @IsOptional()
  cheque_number?: string;

  @IsOptional()
  discount_code?: string;

  // If an payment intent has been created, need to update it with re-calcualted amounts
  @IsOptional()
  payment_intent_id?: string;

  @IsOptional()
  transaction_id?: string;

  /**
   * Client-side monotonically increasing sequence for payment-summary requests
   * that target a transaction. The server refuses to persist amounts from a
   * request with a lower sequence than one it has already applied, so two
   * in-flight summary requests can never leave the transaction / PaymentIntent
   * holding the amounts of the OLDER one.
   */
  @IsOptional()
  summary_sequence?: number;

  @IsNotEmpty()
  owner_id: string;

  @IsOptional()
  date_received?: Date;

  @IsOptional()
  need_check_waitlists?: boolean;

  @IsOptional()
  club_points_to_redeem?: number;

  @IsOptional()
  override_note?: string;
}
